// import React, { useEffect, useState } from "react";
// import { Plus } from "lucide-react";
// import { Box, Modal } from "@mui/material";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import UserAddressCard from "./UserAddressCard";
// import AddressForm from "../Checkout/AddresssForm";
// import { Address } from "../../../types/userTypes";
// import {
//   addUserAddress,
//   deleteUserAddress,
//   fetchUserAddresses,
//   updateUserAddress,
// } from "../../../Redux Toolkit/Customer/UserSlice";

// const modalStyle = {
//   position: "fixed" as const,
//   top: "52%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "calc(100% - 24px)",
//   maxWidth: "620px",
//   outline: "none",
//   bgcolor: "transparent",
//   boxShadow: "none",
//   p: 0,
//   overflow: "hidden",
// };

// const Addresses = () => {
//   const dispatch = useAppDispatch();
//   const { user } = useAppSelector((store) => store);

//   const [open, setOpen] = useState(false);
//   const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);

//   const addresses =
//     user.addresses && user.addresses.length > 0
//       ? user.addresses
//       : user.user?.addresses || [];

//   const handleOpen = () => {
//     setSelectedAddress(null);
//     setOpen(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedAddress(null);
//     document.body.style.overflow = "";
//   };

//   useEffect(() => {
//     const jwt = localStorage.getItem("jwt") || "";

//     if (jwt) {
//       dispatch(fetchUserAddresses({ jwt }));
//     }

//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [dispatch]);

//   const handleAddressSubmit = async (address: Address) => {
//     const jwt = localStorage.getItem("jwt") || "";

//     if (!jwt) return;

//     if (selectedAddress?.id) {
//       await dispatch(
//         updateUserAddress({
//           jwt,
//           addressId: Number(selectedAddress.id),
//           address,
//         })
//       );
//     } else {
//       await dispatch(
//         addUserAddress({
//           jwt,
//           address,
//         })
//       );
//     }

//     await dispatch(fetchUserAddresses({ jwt }));
//     handleClose();
//   };

//   const handleEditAddress = (address: Address) => {
//     setSelectedAddress(address);
//     setOpen(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleDeleteAddress = async (id: number | string | undefined) => {
//     if (!id) return;

//     const jwt = localStorage.getItem("jwt") || "";

//     if (!jwt) return;

//     await dispatch(
//       deleteUserAddress({
//         jwt,
//         addressId: Number(id),
//       })
//     );

//     await dispatch(fetchUserAddresses({ jwt }));
//   };

//   return (
//     <div className="space-y-5">
//       <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-6">
//         <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
//           <div>
//             <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">
//               My Addresses
//             </h1>

//             <p className="mt-1 text-sm text-gray-500">
//               Manage your saved delivery addresses
//             </p>
//           </div>

//           <button
//             onClick={handleOpen}
//             className="flex items-center justify-center gap-2 rounded-lg border border-primary-color px-4 py-2 text-sm font-medium text-primary-color transition hover:bg-gray-100"
//           >
//             <Plus size={17} />
//             Add New Address
//           </button>
//         </div>
//       </div>

//       {addresses.length > 0 ? (
//         <div className="space-y-4">
//           {addresses.map((item: Address, index: number) => (
//             <UserAddressCard
//               key={item.id || index}
//               item={item}
//               onEdit={() => handleEditAddress(item)}
//               onDelete={() => handleDeleteAddress(item.id)}
//             />
//           ))}
//         </div>
//       ) : (
//         <div className="rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
//           <h2 className="text-lg font-semibold text-gray-900">
//             No address added yet
//           </h2>

//           <p className="mt-1 text-sm text-gray-500">
//             Add a new address to make checkout faster.
//           </p>

//           <button
//             onClick={handleOpen}
//             className="mt-5 rounded-lg border border-primary-color px-5 py-2 text-sm font-medium text-primary-color transition hover:bg-gray-100"
//           >
//             Add New Address
//           </button>
//         </div>
//       )}

//       <Modal open={open} onClose={handleClose} disableScrollLock>
//         <Box sx={modalStyle}>
//           <AddressForm
//             mode="profile"
//             handleClose={handleClose}
//             onAddressSubmit={handleAddressSubmit}
//             initialAddress={selectedAddress}
//           />
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default Addresses;




import React, { useEffect, useMemo, useState } from "react";
import { Plus } from "lucide-react";
import { Box, Modal } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import UserAddressCard from "./UserAddressCard";
import AddressForm from "../Checkout/AddresssForm";
import { Address } from "../../../types/userTypes";
import {
  addUserAddress,
  deleteUserAddress,
  fetchUserAddresses,
  updateUserAddress,
} from "../../../Redux Toolkit/Customer/UserSlice";

const modalStyle = {
  position: "fixed" as const,
  top: "52%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 24px)",
  maxWidth: "620px",
  outline: "none",
  bgcolor: "transparent",
  boxShadow: "none",
  p: 0,
  overflow: "hidden",
};

const Addresses = () => {
  const dispatch = useAppDispatch();

  const userAddresses = useAppSelector((store) => store.user.addresses);
  const profileAddresses = useAppSelector(
    (store) => store.user.user?.addresses
  );

  const [open, setOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);

  const addresses = useMemo(() => {
    const sourceAddresses =
      userAddresses && userAddresses.length > 0
        ? userAddresses
        : profileAddresses || [];

    return sourceAddresses.filter(
      (address: Address) => !Boolean(address.deleted)
    );
  }, [userAddresses, profileAddresses]);

  const handleOpen = () => {
    setSelectedAddress(null);
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedAddress(null);
    document.body.style.overflow = "";
  };

  useEffect(() => {
    const jwt = localStorage.getItem("jwt") || "";

    if (jwt) {
      dispatch(fetchUserAddresses({ jwt }));
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [dispatch]);

  const handleAddressSubmit = async (address: Address) => {
    const jwt = localStorage.getItem("jwt") || "";

    if (!jwt) return;

    if (selectedAddress?.id) {
      await dispatch(
        updateUserAddress({
          jwt,
          addressId: Number(selectedAddress.id),
          address,
        })
      );
    } else {
      await dispatch(
        addUserAddress({
          jwt,
          address,
        })
      );
    }

    await dispatch(fetchUserAddresses({ jwt }));
    handleClose();
  };

  const handleEditAddress = (address: Address) => {
    setSelectedAddress(address);
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleDeleteAddress = async (id: number | string | undefined) => {
    if (!id) return;

    const jwt = localStorage.getItem("jwt") || "";

    if (!jwt) return;

    await dispatch(
      deleteUserAddress({
        jwt,
        addressId: Number(id),
      })
    );

    await dispatch(fetchUserAddresses({ jwt }));
  };

  return (
    <div className="space-y-5">
      <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">
              My Addresses
            </h1>

            <p className="mt-1 text-sm text-gray-500">
              Manage your saved delivery addresses
            </p>
          </div>

          <button
            onClick={handleOpen}
            className="flex items-center justify-center gap-2 rounded-lg border border-primary-color px-4 py-2 text-sm font-medium text-primary-color transition hover:bg-gray-100"
          >
            <Plus size={17} />
            Add New Address
          </button>
        </div>
      </div>

      {addresses.length > 0 ? (
        <div className="space-y-4">
          {addresses.map((item: Address, index: number) => (
            <UserAddressCard
              key={item.id || index}
              item={item}
              onEdit={() => handleEditAddress(item)}
              onDelete={() => handleDeleteAddress(item.id)}
            />
          ))}
        </div>
      ) : (
        <div className="rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
          <h2 className="text-lg font-semibold text-gray-900">
            No address added yet
          </h2>

          <p className="mt-1 text-sm text-gray-500">
            Add a new address to make checkout faster.
          </p>

          <button
            onClick={handleOpen}
            className="mt-5 rounded-lg border border-primary-color px-5 py-2 text-sm font-medium text-primary-color transition hover:bg-gray-100"
          >
            Add New Address
          </button>
        </div>
      )}

      <Modal open={open} onClose={handleClose} disableScrollLock>
        <Box sx={modalStyle}>
          <AddressForm
            mode="profile"
            handleClose={handleClose}
            onAddressSubmit={handleAddressSubmit}
            initialAddress={selectedAddress}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default Addresses;